import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import Team from "@/components/Team";
import DualPortal from "@/components/DualPortal";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => {
  return (
    <main className="bg-white text-brand-ink min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Industries />
      <Team />
      <DualPortal />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
